import React from 'react';
import Skeleton from 'react-loading-skeleton';
import "../../../assets/css/ArticulationForm.css";
import SkeletonReRegistrationArticulationList from '../../../loaders/SkeletonReRegistrationArticulationList';
import { getFormattedArticulationPrice } from '../../../utils/Articulation-Util';
import CommonCourseComponents from '../../course/CommonCourseComponents';
import { lblHeader, lblOtherText, lblQualificationText } from './Consts';

/**
 * Step 1. Select Qualification
 * @param {object} props 
 * @returns 
 */
function ArticulationSelectQualification({
    articulationOptionSelected,
    articulationOptions,
    campusList,
    isLoading,
    learningMaterialsList,
    schoolTypes,
    setArticulationOption,
    setCurrentStep
}) {
    const renderCheckbox = (value) => {
        return (
            <label className="round-checkbox">
                <input
                    type="radio"
                    checked={articulationOptionSelected === value}
                    onChange={() => {
                        setArticulationOption(value);
                    }}
                />
                <span className="checkmark"></span>
            </label>
        );
    };

    const renderArtOption = (option) => {
        const schoolValue = (() => {
            if (schoolTypes?.length > 0) {
                return schoolTypes.find(x => x.value === option.school);
            }
            return '';
        })();

        const renderLearningMethod = (learningMethod) => {
            const icon = (() => {
                switch (learningMethod.value) {
                    case 'full':
                        return 'university';
                    case 'fulltimeonline':
                        return 'laptop';
                    case 'parttimeonline':
                    default:
                        return 'clock';
                }
            })();
            return (
                <span key={learningMethod.value}>
                    <i class={`fal fa-${icon}`}></i>{learningMethod.label}
                </span>
            );
        };

        const bgStyleProps = option.categoryColor && { "--bg-category-color": option.categoryColor };

        return (
            <div
                key={option.id}
                className={`art-option-card ${articulationOptionSelected?.id === option.id ? 'pc-option-selected' : ''}`}
                onClick={() => setArticulationOption(option)}>
                <div className="pc-header" style={bgStyleProps}>
                    <div>{schoolValue?.label ?? ''}</div>{renderCheckbox(option)}
                </div>

                <div className="padded-container">
                    <div className="pc-badge">{CommonCourseComponents({ degree: option.type })}</div>

                    <h3 className="pc-title">{option.name}</h3>

                    <div className="pc-section">
                        <div className="pc-label"><i className="fal fa-tags"></i> Pricing</div>
                        <div className="pc-value">From <strong>{getFormattedArticulationPrice(option)}</strong> (T&C)</div>
                    </div>

                    {
                        campusList.length > 0 && option.campuses?.length > 0 && (
                            <div className="pc-section">
                                <div className="pc-label"><i className="fal fa-map-marker-alt"></i> Campus Locations</div>

                                <div className="pc-tags">
                                    {option.campuses.map((curCampus) => {
                                        const item = campusList.find(x => x.value === curCampus.slug);
                                        if(!item) return null;
                                        return (
                                            <span key={item.value} style={{ color: item.color, background: `color-mix(in srgb, ${item.color} 10%, white)` }}>{item.label}</span>
                                        );
                                    })}
                                </div>
                            </div>)
                    }

                    {learningMaterialsList.length > 0 && option.learningMethods?.length > 0 && (
                        <div className="pc-section">
                            <div className="pc-label"><i className="fal fa-laptop"></i> Learning Methods</div>
                            <div className="pc-tags">
                                {option.learningMethods.map((curLearningMethod) => {
                                    const learningMethod = learningMaterialsList.find(x => x.value === curLearningMethod);
                                    return renderLearningMethod(learningMethod);
                                })}
                            </div>
                        </div>
                    )}

                    {option.url &&
                        <button style={bgStyleProps} title="Learn More" className="btn btn-more pc-button" onClick={() => window.open(option.url, "_blank")}>
                            Learn More
                        </button>
                    }
                </div>
            </div>
        );
    };

    return (
        <div className="articulationForm">
            <h4 className="ao-sub-header">{isLoading ? <Skeleton width={150} /> : lblHeader}</h4>
            <h4 className="ao-sub-description">{isLoading ? <Skeleton /> : lblQualificationText}</h4>
            <div className="ao-container">
                <div className="articulation-grid">
                    {isLoading ? (
                        <SkeletonReRegistrationArticulationList />
                    ) : articulationOptions.map((option) => {
                        return renderArtOption(option);
                    })}
                </div>
                {isLoading ? <Skeleton height={30} /> : (
                    <div className={`base-card otherOption ${articulationOptionSelected === 'other' ? 'pc-option-selected' : ''}`}
                        onClick={() => setArticulationOption('other')}>
                        <div>{lblOtherText}</div>
                        {renderCheckbox('other')}
                    </div>
                )}
                {articulationOptionSelected &&
                    <div>
                        <button title="Next" className="btn btn-main btn-primary" onClick={() => setCurrentStep(1)}>
                            Next
                        </button>
                    </div>
                }
            </div>
        </div>
    );
}

export default ArticulationSelectQualification;
